import { Paper, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

interface Props {
    title: string;
    description?: string;
    children: ReactElement;
}

const Setting = ({ title, description, children }: Props) => {
    return (
        <Paper sx={{ padding: 2 }}>
            <Stack
              spacing={{
                xs: 3,
                md: 2,
              }}
              direction={{
                md: 'row'
              }}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Stack>
                <Typography variant="h4">{title}</Typography>
                {description ? (
                    <Typography variant="body1" color="text.secondary">
                    {description}
                    </Typography>
                ) : null}
              </Stack>
              <Stack
                spacing={2}
                direction={'row'}
                alignItems={'center'}
                justifyContent={'flex-end'}
              >
                {children}
              </Stack>
            </Stack>
        </Paper>
    )
}

export default Setting;
